<template>
  <div class="financial-statement-item">
    <col-table :data="financeData" :pageSize="pageSize" :class="{ 'col-table--same': isSame, 'table-var': true }">
      <col-table-column label="日期" prop="endDate" :css="{ height: '50px' }">
        <template #header>
          <div class="date-header">
            <span>报告期<i class="iconfont icon-wenhao ml-4px" @click="popupVisible = true"></i></span>
            <span class="tongbi">
              {{ $t('同比')
              }}<span class="checkbox-wrap"><input type="checkbox" v-model="isSame" class="checkbox" /></span>
            </span>
          </div>
        </template>
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ scope.row.sortYear + scope.row.reportType }}</span>
            <span class="scale">{{ $t('同比') }}</span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="endDate" label="报表截止日" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">{{ $digitjs(scope.row.endDate).isNull() }}</template>
      </col-table-column>
      <col-table-column prop="revenue" label="营业收入" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.revenue).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.revenueYoY).color() }" class="scale">
              {{ $digitjs(scope.row.revenueYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="costOfRevenue" label="营业成本" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.costOfRevenue).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.costOfRevenueYoY).color() }" class="scale">
              {{ $digitjs(scope.row.costOfRevenueYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="grossProfit" label="毛利润" :css="{ ...mainDataStyle, marginBottom: '17px' }">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.grossProfit).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.grossProfitYoY).color() }" class="scale">
              {{ $digitjs(scope.row.grossProfitYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>经营费用</template>
      </col-table-column>
      <col-table-column prop="operatingExpenses" label="营业费用">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.operatingExpenses).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.operatingExpensesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.operatingExpensesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="salesAndManagement" label="销售和管理费用">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.salesAndManagement).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.salesAndManagementYoY).color() }" class="scale">
              {{ $digitjs(scope.row.salesAndManagementYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="salesExpenses" label="- 销售费用">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.salesExpenses).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.salesExpensesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.salesExpensesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="managementExpenses" label="- 管理费用">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.managementExpenses).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.managementExpensesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.managementExpensesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="depreciationAndAmortization" label="折旧及摊销">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.depreciationAndAmortization).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.depreciationAndAmortizationYoY).color() }" class="scale">
              {{ $digitjs(scope.row.depreciationAndAmortizationYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="impairment" label="减值及拨备">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.impairment).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.impairmentYoY).color() }" class="scale">
              {{ $digitjs(scope.row.impairmentYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="productDevelopmentExpenses" label="研发费用">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.productDevelopmentExpenses).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.productDevelopmentExpensesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.productDevelopmentExpensesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="operatingProfit" label="营业利润" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.operatingProfit).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.operatingProfitYoY).color() }" class="scale">
              {{ $digitjs(scope.row.operatingProfitYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="netInterestIncome" label="净非营业利息收入" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.netInterestIncome).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.netInterestIncomeYoY).color() }" class="scale">
              {{ $digitjs(scope.row.netInterestIncomeYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="interestIncome" label="利息收入">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.interestIncome).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.interestIncomeYoY).color() }" class="scale">
              {{ $digitjs(scope.row.interestIncomeYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="interestExpense" label="利息支出">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.interestExpense).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.interestExpenseYoY).color() }" class="scale">
              {{ $digitjs(scope.row.interestExpenseYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherIncome" label="其他非经营收入">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.otherIncome).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.otherIncomeYoY).color() }" class="scale">
              {{ $digitjs(scope.row.otherIncomeYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="incomeBeforeTax" label="税前利润" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.incomeBeforeTax).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.incomeBeforeTaxYoY).color() }" class="scale">
              {{ $digitjs(scope.row.incomeBeforeTaxYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="incomeTaxExpenses" label="所得税" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.incomeTaxExpenses).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.incomeTaxExpensesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.incomeTaxExpensesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="equityMethodInvestees" label="权益性投资收益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.equityMethodInvestees).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.equityMethodInvesteesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.equityMethodInvesteesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="profitAfterTax" label="净利率" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.profitAfterTax).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.profitAfterTaxYoY).color() }" class="scale">
              {{ $digitjs(scope.row.profitAfterTaxYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="ongoingOperatingIncome" label="持续经营利润">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.ongoingOperatingIncome).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.ongoingOperatingIncomeYoY).color() }" class="scale">
              {{ $digitjs(scope.row.ongoingOperatingIncomeYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="minorityEquity" label="归属于少数股东的净利润" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.minorityEquity).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.minorityEquityYoY).color() }" class="scale">
              {{ $digitjs(scope.row.minorityEquityYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="groupHoldingLimitedEquity" label="归属于母公司的净利润" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.groupHoldingLimitedEquity).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.groupHoldingLimitedEquityYoY).color() }" class="scale">
              {{ $digitjs(scope.row.groupHoldingLimitedEquityYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="accretionOfMezzanineEquity" label="其他优先股派息" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.accretionOfMezzanineEquity).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.accretionOfMezzanineEquityYoY).color() }" class="scale">
              {{ $digitjs(scope.row.accretionOfMezzanineEquityYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column
        prop="ordinaryShareholdersEquity"
        label="归属于普通股股东的净利润"
        :css="{ ...mainDataStyle, marginBottom: '17px' }"
      >
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.ordinaryShareholdersEquity).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.ordinaryShareholdersEquityYoY).color() }" class="scale">
              {{ $digitjs(scope.row.ordinaryShareholdersEquityYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalComprehensiveIncome" label="综合收益总额">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.totalComprehensiveIncome).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.totalComprehensiveIncomeYoY).color() }" class="scale">
              {{ $digitjs(scope.row.totalComprehensiveIncomeYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherComprehensiveIncome" label="其他综合收益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.otherComprehensiveIncome).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.otherComprehensiveIncomeYoY).color() }" class="scale">
              {{ $digitjs(scope.row.otherComprehensiveIncomeYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="nonControllingComprehensiveIncome" label="- 归属于少数股东的全面收益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.nonControllingComprehensiveIncome).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.nonControllingComprehensiveIncomeYoY).color() }" class="scale">
              {{ $digitjs(scope.row.nonControllingComprehensiveIncomeYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column
        prop="shareholdersComprehensiveIncome"
        label="- 归属于母公司股东的全面收益"
        :css="{ marginBottom: '17px' }"
      >
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.shareholdersComprehensiveIncome).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.shareholdersComprehensiveIncomeYoY).color() }" class="scale">
              {{ $digitjs(scope.row.shareholdersComprehensiveIncomeYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>每股指标</template>
      </col-table-column>
      <col-table-column prop="epsBasic" label="基本每股收益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.epsBasic).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.epsBasicYoY).color() }" class="scale">
              {{ $digitjs(scope.row.epsBasicYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="epsDiluted" label="稀释每股收益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.epsDiluted).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.epsDilutedYoY).color() }" class="scale">
              {{ $digitjs(scope.row.epsDilutedYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="epsBasicOrdinary" label="基本每股收益-普通股">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.epsBasicOrdinary).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.epsBasicOrdinaryYoY).color() }" class="scale">
              {{ $digitjs(scope.row.epsBasicOrdinaryYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="epsDilutedOrdinary" label="稀释每股收益-普通股">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.epsDilutedOrdinary).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.epsDilutedOrdinaryYoY).color() }" class="scale">
              {{ $digitjs(scope.row.epsDilutedOrdinaryYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="dpsOrdinary" label="每股股息-普通股" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.dpsOrdinary).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.dpsOrdinaryYoY).color() }" class="scale">
              {{ $digitjs(scope.row.dpsOrdinaryYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="accountingStandard" label="会计准则">
        <template slot-scope="scope">
          {{ $digitjs(scope.row.accountingStandard).isNull() }}
        </template>
      </col-table-column>
      <col-table-column prop="balanceSheetDate" label="年结日">
        <template slot-scope="scope">
          {{ $digitjs(scope.row.balanceSheetDate).isNull() }}
        </template>
      </col-table-column>
      <col-table-column prop="reportDate" label="公布日期" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">
          {{ $digitjs(scope.row.reportDate).isNull() }}
        </template>
      </col-table-column>
    </col-table>
    <RkPopup :visible.sync="popupVisible"><ReportSheetPrompt /></RkPopup>
  </div>
</template>

<script>
import RkPopup from '@/components/common/Popup.vue'
import ReportSheetPrompt from '@/components/common/ReportSheetPrompt.vue'
export default {
  components: { RkPopup, ReportSheetPrompt },
  props: ['css', 'mainDataStyle'],
  data() {
    return {
      isSame: false,
      popupVisible: false,
      financeData: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    pageSize() {
      return this.isSame ? 1 : 2
    }
  },
  created() {
    this.getIncomeStatement()
  },
  methods: {
    async getIncomeStatement() {
      const res = await this.$post(this.$api.f10.us + '/finance/income-basic', {
        symbol: this.symbol,
        reportSize: 20,
        reportTypes: ['FY', 'Q4', 'Q9', 'Q3', 'Q6', 'Q2', 'Q1']
      })
      const reportTypeMap = {
        FY: 7,
        Q4: 6,
        Q9: 5,
        Q3: 4,
        Q6: 3,
        Q2: 2,
        Q1: 1
      }
      const data =
        res.data?.map((item) => {
          const { endDate, balanceSheetDate } = item
          const year = this.$dayjs(endDate).format('YYYY')
          const isBefore = this.$dayjs(year + '/' + balanceSheetDate).isBefore(this.$dayjs(endDate))
          item.sortYear = isBefore ? +year + 1 : +year
          return item
        }) ?? []
      this.financeData = data.sort(
        (a, b) => b.sortYear - a.sortYear || reportTypeMap[b.reportType] - reportTypeMap[a.reportType]
      )
    }
  }
}
</script>
